export class SelfAssessment {
    id: number;
    rulebookRuleID: string;
    libraryName: string;
    title: string;
    geography: string;
    country: string;
    regulator: string;
    effectiveDate: string;
    ruleBook: string;
    title1: string;
    title2: string;
    title3: string;
    title4: string;
    title5: string;
    ruleID: string;
    regulatoryRuleFullRequirement: string;
    hyperlink: string;
    insertedRow: number;
    editableRow: number;
    ruleApplicable: string;
    rationaleifNo: string;
    assessmentTeam: string;
    assessor: string;
    assessorDelegate: string;
    assessmentDetails: string;
    assessmentLastEdited: Date | null;
    assessmentDueDate: Date | null;
    assessmentStatus: string;
    reviewTeam: string;
    reviewer: string;
    reviewerDelegate: string;
    reviewDetails: string;
    reviewLastEdited: Date | null;
    reviewDueDate: Date | null;
    reviewStatus: string;
    overallStatus: string;
    overallConclusion: string;
    ruleConclusion: string;
    gapDescription: string;
    gapReviewStatus: string;
    actionTeam: string;
    actionOwner: string;
    remediationAction: string;
    actionLastEdited: Date | null;
    actionDueDate: Date | null;
    actionStatus: string;
    closureRationale: string;
    enhancementDescription: string;
    enhancementReviewStatus: string;
    enhancementActionTeam: string;
    enhancementActionOwner: string;
    enhancementAction: string;
    enhancementActionLastEdited: Date | null;
    enhancementActionDueDate: Date | null;
    enhancementActionStatus: string;
    versionNumber: number;
    userId: string;
    userName: string;
    part:string;
    owner:string;
    isSendNotification: boolean;
    createdDateTime: Date | null;


    constructor() {
        this.id = 0;
        this.rulebookRuleID = '';
        this.libraryName = '';
        this.title = '';
        this.geography = '';
        this.country = '';
        this.regulator = '';
        this.effectiveDate = '';
        this.ruleBook = '';
        this.title1 = '';
        this.title2 = '';
        this.title3 = '';
        this.title4 = '';
        this.title5 = '';
        this.ruleID = '';
        this.regulatoryRuleFullRequirement = '';
        this.hyperlink = '';
        this.insertedRow = 0;
        this.editableRow = 0;
        this.ruleApplicable = '';
        this.rationaleifNo = '';
        this.assessmentTeam = '';
        this.assessor = '';
        this.assessorDelegate = '';
        this.assessmentDetails = '';
        this.assessmentLastEdited =  null;
        this.assessmentDueDate = null;
        this.assessmentStatus = '';
        this.reviewTeam = '';
        this.reviewer = '';
        this.reviewerDelegate = '';
        this.reviewDetails = '';
        this.reviewLastEdited = null;
        this.reviewDueDate = null;
        this.reviewStatus = '';
        this.overallStatus = '';
        this.overallConclusion = '';
        this.ruleConclusion = '';
        this.gapDescription = '';
        this.gapReviewStatus = '';
        this.actionTeam = '';
        this.actionOwner = '';
        this.remediationAction = '';
        this.actionLastEdited = null;
        this.actionDueDate = null;
        this.actionStatus = '';
        this.enhancementDescription = '';
        this.enhancementReviewStatus = '';
        this.enhancementActionTeam = '';
        this.enhancementActionOwner = '';
        this.enhancementAction = '';
        this.enhancementActionLastEdited = null;
        this.enhancementActionDueDate = null;
        this.enhancementActionStatus = '';
        this.closureRationale = '';
        this.versionNumber = 0;
        this.userId = '';
        this.userName = '';
        this.part = '';
        this.owner = '';
        this.isSendNotification = false;
        this.createdDateTime = null;
    }
}

export class BulkSelfAssessment {
    id: number;
    rulebookRuleID: string;
    libraryName: string;
    title: string;
    geography: string;
    country: string;
    regulator: string;
    effectiveDate: string;
    ruleBook: string;
    title1: string;
    title2: string;
    title3: string;
    title4: string;
    title5: string;
    ruleID: string;
    regulatoryRuleFullRequirement: string;
    hyperlink: string;
    insertedRow: number;
    editableRow: number;
    ruleApplicable: string;
    rationaleifNo: string;
    assessmentTeam: string;
    assessor: string;
    assessorDelegate: string;
    assessmentDetails: string;
    assessmentDueDate: Date | null;
    assessmentStatus: string;
    reviewTeam: string;
    reviewer: string;
    reviewerDelegate: string;
    reviewDetails: string;
    reviewDueDate: Date | null;
    reviewStatus: string;
    overallStatus: string;
    overallConclusion: string;
    ruleConclusion: string;
    gapDescription: string;
    gapReviewStatus: string;
    actionTeam: string;
    actionOwner: string;
    remediationAction: string;
    actionDueDate: Date | null;
    actionStatus: string;
    closureRationale: string;
    enhancementDescription: string;
    enhancementReviewStatus: string;
    enhancementActionTeam: string;
    enhancementActionOwner: string;
    enhancementAction: string;
    enhancementActionDueDate: Date | null;
    enhancementActionStatus: string;
    versionNumber: number;
    userId: string;
    userName: string;
    part:string;
    owner:string;
    isSendNotification: boolean;


    constructor() {
        this.id = 0;
        this.rulebookRuleID = '';
        this.libraryName = '';
        this.title = '';
        this.geography = '';
        this.country = '';
        this.regulator = '';
        this.effectiveDate = '';
        this.ruleBook = '';
        this.title1 = '';
        this.title2 = '';
        this.title3 = '';
        this.title4 = '';
        this.title5 = '';
        this.ruleID = '';
        this.regulatoryRuleFullRequirement = '';
        this.hyperlink = '';
        this.insertedRow = 0;
        this.editableRow = 0;
        this.ruleApplicable = '';
        this.rationaleifNo = '';
        this.assessmentTeam = '';
        this.assessor = '';
        this.assessorDelegate = '';
        this.assessmentDetails = '';
        this.assessmentDueDate = null;
        this.assessmentStatus = '';
        this.reviewTeam = '';
        this.reviewer = '';
        this.reviewerDelegate = '';
        this.reviewDetails = '';
        this.reviewDueDate = null;
        this.reviewStatus = '';
        this.overallStatus = '';
        this.overallConclusion = '';
        this.ruleConclusion = '';
        this.gapDescription = '';
        this.gapReviewStatus = '';
        this.actionTeam = '';
        this.actionOwner = '';
        this.remediationAction = '';
        this.actionDueDate = null;
        this.actionStatus = '';
        this.enhancementDescription = '';
        this.enhancementReviewStatus = '';
        this.enhancementActionTeam = '';
        this.enhancementActionOwner = '';
        this.enhancementAction = '';
        this.enhancementActionDueDate = null;
        this.enhancementActionStatus = '';
        this.closureRationale = '';
        this.versionNumber = 0;
        this.userId = '';
        this.userName = '';
        this.part = '';
        this.owner = '';
        this.isSendNotification = false;
    }
}